import { BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';

export default function registerEnsureParagraphAfterImageFileInsert(
  editor: BlockNoteEditor<BlockSchema>,
  onImageInserted: (blockId: string) => void,
): () => void {
  return editor.onChange((_editor, context) => {
    for (const change of context.getChanges()) {
      const isPasteOrDropSource =
        change.source.type === 'paste' || change.source.type === 'drop';

      if (!isPasteOrDropSource || change.block.type !== 'image') {
        continue;
      }

      const becameImage =
        change.type === 'insert' ||
        (change.type === 'update' &&
          change.prevBlock !== undefined &&
          change.prevBlock.type !== 'image');

      if (becameImage) {
        onImageInserted(change.block.id);
      }
    }
  });
}
